import { connect } from 'react-redux';
import { getFTTBAdditionalPopupError } from 'pages/Internet/store/selectors/servicesSelectors';
import { PopupText } from '../../../../components';

export const ErrorTitle = connect((state) => ({
  children: getFTTBAdditionalPopupError(state).title || 'Ошибка',
  isTitle: true,
}))(PopupText);

export const ErrorText = connect((state) => ({
  children: getFTTBAdditionalPopupError(state).text || 'Что-то пошло не так',
}))(PopupText);
